module.exports = __webpack_public_path__ + "img/grdf.11112546.jpg";